import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';

import { environment } from '@unico-people/benefits-form/enviroment';
import { clearStorage, getTokenStorage } from '@unico-people/shared/utils/storage';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private identity_url: string = environment.identity_url;
  private base_url: string = environment.base_url;

  constructor(public jwtHelper: JwtHelperService) {}

  loggedIn() {
    const token: string = getTokenStorage();
    return token != null && !this.jwtHelper.isTokenExpired(token);
  }
  logout() {
    clearStorage();
    window.location.href = `${this.identity_url}/signout?redirect_uri=${this.base_url}/logout`;
  }
}
